import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { LiveArticleContentItem } from "./item";

export const Container = styled.div``;

export const StyledLiveArticleContentItem = styled(LiveArticleContentItem)`
  margin-block-start: 40px;
`;

export const AdSlotContainer = styled.div`
  display: none;

  margin-block-start: 32px;

  ${theme.breakpoints.down("desktop")} {
    display: block;
  }
`;
